import * as accountActions from '@mnz-modules/login/store/actions/account.actions';
import { createReducer, on } from '@ngrx/store';

export const initialState: IAccountState = {
  loading: false,
};

export interface IAccountState {
  readonly loading: boolean;
}

export const reducer = createReducer(
  initialState,
  on(accountActions.activateAccount, accountActions.resetAccount, (state) => ({
    ...state,
    loading: true,
  })),
  on(
    accountActions.activateAccountFail,
    accountActions.resetAccountFail,
    accountActions.activateAccountSuccess,
    accountActions.resetAccountSuccess,
    (state) => ({
      ...state,
      loading: false,
    })
  )
);
